import { Link } from 'react-router-dom';

import { Card } from '../components/Card.js';

const UPDATED = '2026-10-20';

/**
 * 隐私政策（公开页，无需登录）。
 * 内容纪律：只写系统真实在做的事——字段清单、用途、期限、AI 第三方处理、用户权利，
 * 全部与当前实现一一对应（数据导出 / 账号删除入口真实存在于「设置与合规」页）。
 */
export function PrivacyPage() {
  return (
    <div className="auth-shell">
      <div className="landing-wrap">
        <Card title="隐私政策" subtitle={`最后更新：${UPDATED} · 版本 v1.0`}>
          <div className="legal-doc">
            <p>
              CrossMatch（以下简称「本平台」）是面向松江七校高校学生的赛事组队匹配工具。本政策说明我们收集哪些信息、
              用来做什么、保存多久、以及你的权利。本政策与《用户协议》共同构成你使用本平台的基础。
            </p>

            <h3>一、我们收集什么</h3>
            <ul>
              <li>
                <strong>账号信息</strong>：邮箱、姓名/昵称、所在学校（从固定列表选择）。不收集学号、手机号、身份证号。
              </li>
              <li>
                <strong>登录凭证</strong>：密码以 scrypt 加盐哈希形式保存，平台不存储明文，任何管理员无法查看你的原密码。
              </li>
              <li>
                <strong>画像与匹配数据</strong>：你填写的技能、每周可投入时间、时间档；你录入的候选人信息；你的组队、匹配与待办记录。
              </li>
              <li>
                <strong>安全日志</strong>：为防爆破与限频，服务端会记录接口调用的 IP 地址与时间，仅用于安全目的。
              </li>
            </ul>

            <h3>二、这些信息用来做什么</h3>
            <ul>
              <li>识别你的账号、保障账号与平台安全；</li>
              <li>计算跨校互补匹配、生成推荐理由、支持组队与备赛协同；</li>
              <li>在你使用 AI 功能时提供对话与解读（见「第三方处理」一节）。</li>
            </ul>

            <h3>三、保存在哪、存多久</h3>
            <p>
              数据保存在本平台位于中国大陆境内的服务器数据库中，传输全程 HTTPS 加密。保存期限为你的账号存续期间；
              注销账号后，个人字段将被匿名化处理，无法再关联到你本人，由此产生的聚合统计（如各校用户数）不再包含你的可识别信息。
            </p>

            <h3>四、会共享给第三方吗</h3>
            <p>
              不共享、不出售、不用于广告推送。唯一例外：当你使用 AI
              队友、推荐理由、赛事需求抽取等功能时，平台会将必要的画像摘要发送至平台所配置的大模型服务商进行处理，
              相关界面会标注「AI 生成」；未配置该服务时，功能自动降级为规则解读，并同样如实标注，不假装智能。
              除法律法规要求或配合有权机关调查外，我们不会向任何第三方提供你的个人信息。
            </p>

            <h3>五、你的权利</h3>
            <ul>
              <li>查询与更正：随时在「我的画像」「设置与合规」查看、修改你的信息；</li>
              <li>
                导出：「设置与合规 → 导出我的数据」，一键下载包含画像、匹配与组队记录的全量 JSON；
              </li>
              <li>
                删除：「设置与合规 → 删除账号」，二次确认后注销，全部登录凭据立即失效；
              </li>
              <li>对以上权利有疑问或需要帮助：通过站内反馈联系平台管理员。</li>
            </ul>

            <h3>六、安全措施</h3>
            <p>
              scrypt 密码哈希（代价参数 N=16384，随机加盐）、HTTPS 传输加密、登录 IP 与邮箱双维度限频、
              短期有效的访问令牌与可撤销的刷新令牌。一旦发生安全事件，我们会在 72
              小时内通过站内公告告知受影响的用户。
            </p>

            <h3>七、未成年人</h3>
            <p>本平台面向高校学生群体。如你未满 18 周岁，请在监护人陪同下阅读本政策并使用本平台。</p>

            <h3>八、政策更新</h3>
            <p>
              重大变更会通过站内公告提示，并更新本页顶部的「最后更新」日期；继续使用即视为接受更新后的政策。
            </p>

            <p className="muted small">
              返回<Link to="/">首页</Link>，或查看<Link to="/terms">《用户协议》</Link>。
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
}
